export default {
  props: {
    iconLeft: {
      type: String,
      required: false,
    },
    iconRight: {
      type: String,
      required: false,
    },
  },
  methods: {
    onClick() {
      this.$emit("click");
    },
  },
};
